export default __webpack_public_path__ + "static/media/portadavideoforecast1nuevo.cabe4600.png";